<div *ngIf="status">
    <app-hyperlink-creator
        mode="hyperlinkOnly"
        [displayText]="status"
        (onLinkClick)="onStatusClick()"
    ></app-hyperlink-creator>
</div>
